/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

function WelcomePageDetail({
  image,
  title,
  subtitle,
  show,
}) {
  const imageClasses = useMemo(() => (
    `dtv-html5-c-welcome-page-detail__image ${show ? '' : 'dtv-html5-c-welcome-page-detail--hidden'}`
  ), [show]);

  const infoClasses = useMemo(() => (
    `dtv-html5-c-welcome-page-detail__info ${show ? '' : 'dtv-html5-c-welcome-page-detail--hidden'}`
  ), [show]);

  return (
    <div className="dtv-html5-c-welcome-page-detail">
      <img className={imageClasses} src={image} alt={title} />
      <div className={infoClasses}>
        <h1 className="dtv-html5-c-welcome-page-detail__info__title">
          {title}
        </h1>
        <h2 className="dtv-html5-c-welcome-page-detail__info__subtitle">
          {subtitle}
        </h2>
      </div>
    </div>
  );
}

WelcomePageDetail.propTypes = {
  image: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
  show: PropTypes.bool,
};

WelcomePageDetail.defaultProps = {
  show: false,
};

export default memo(WelcomePageDetail);
